// @ts-nocheck da5df5e1
import React from 'react';
import PropTypes from 'prop-types';
import * as util from '#packages/util';
import * as baseUI from '#packages/baseUI';
import * as symbols from '@wix/santa-editor-symbols';
import { cx } from '#packages/util';

function template() {
  return (
    <baseUI.tooltip
      value={
        this.props.isHidden
          ? 'Toolbars_show_hover_label'
          : 'Toolbars_hide_hover_label'
      }
      key="hideAllTools"
    >
      <div
        onClick={() => {
          this.props.toggleHideTools();
        }}
        style={{
          zIndex: this.props.zIndex,
        }}
        className={cx({
          'hide-tools-button': true,
          'hide-tools-button-with-banner':
            this.props.withSectionsMigrationBanner,
          'tools-hidden': this.props.isHidden,
          'tools-hidden-with-banner': this.props.withSectionsMigrationBanner,
          'stand-out': this.props.shouldHideToolsBtnBlink,
        })}
        data-hook="hide-tools-button"
      >
        <symbols.symbol name="hideToolsArrow" className="hide-tools-symbol" />
      </div>
    </baseUI.tooltip>
  );
}

class HideToolsButton extends React.Component {
  render() {
    return template.call(this);
  }
}

HideToolsButton.displyName = 'HideToolsButton';

HideToolsButton.propTypes = {
  isHidden: PropTypes.bool.isRequired,
  toggleHideTools: PropTypes.func.isRequired,
  shouldHideToolsBtnBlink: PropTypes.bool.isRequired,
  withSectionsMigrationBanner: PropTypes.bool,
  zIndex: PropTypes.number,
};

export default util.hoc.renderWhenMutated(HideToolsButton);
